import { render, staticRenderFns } from "./cut_off.vue?vue&type=template&id=df463cc8&scoped=true&"
import script from "./cut_off.vue?vue&type=script&lang=js&"
export * from "./cut_off.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df463cc8",
  null
  
)

export default component.exports